import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'Anti-Cheating & Plagiarism Detection',
    title: 'Ensure fairness with AI-powered integrity',
    subtitle: 'The most comprehensive anti-cheating stack for technical hiring. Monitor, detect, and report suspicious activity across assessments and interviews.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #2C4A6E 50%, #0076A3 100%)',
  },
  sections: [
    {
      label: 'Integrity Stack',
      title: 'Multi-layered protection for every assessment',
      features: [
        { icon: '👁️', title: 'Tab-Switch Detection', desc: 'Monitors when candidates switch browser tabs or windows. Every switch is logged with timestamp and question context.' },
        { icon: '📋', title: 'Copy-Paste Monitoring', desc: 'Detects copy, paste, and cut events during the assessment. Prevents clipboard use with warning dialogs.' },
        { icon: '🔒', title: 'Right-Click Prevention', desc: 'Context menu disabled during active assessments. Attempts are logged as anti-cheat events.' },
        { icon: '⏱️', title: 'Time-Per-Question Tracking', desc: 'Records how long candidates spend on each question. Unusually fast answers are flagged for review.' },
        { icon: '🤖', title: 'AI Answer Detection', desc: 'Proprietary AI model detects answers likely generated by ChatGPT or similar tools. Confidence score per answer.' },
        { icon: '📷', title: 'Face Presence Verification', desc: 'Camera-based monitoring ensures the candidate is present and no additional people are visible during the test.' },
      ],
      columns: 3,
    },
    {
      label: 'Recruiter Visibility',
      title: 'Detailed integrity reports for every candidate',
      desc: 'Recruiters see a complete cheating report alongside assessment results. Every event is timestamped and contextualized.',
      bullets: ['Risk level assessment: Low, Medium, High', 'Event timeline with timestamps', 'Per-question flagging', 'AI-generated likelihood scores', 'Exportable integrity reports'],
      visual: '🛡️',
      visualLabel: 'Integrity Report Dashboard',
    },
  ],
  testimonial: { quote: 'After implementing CHIRE\'s anti-cheating, our assessment integrity improved dramatically. We can finally trust our screening results.', name: 'David L.', role: 'Head of Recruiting, FinTech Co.' },
  cta: { title: 'Protect the integrity of your hiring', desc: 'Every assessment and interview is monitored. Every candidate is evaluated fairly.' },
};

export default function AntiCheatingPage() { return <ProductPageTemplate data={DATA} />; }
